export default "__VITE_ASSET__9194f438__"